import { useCall, useFetchWithErrorTracking } from '@one-snap/core';

interface ContactInformationResponse {
  contactInformation: {
    hours: {
      msStart: string;
      msEnd: string;
      suEnd: string;
      suStart: string;
    };
    phoneNumber: string;
    primaryEmail: string;
  };
}

export function useGetContactInformation() {
  const { fetchWithErrorTracking } = useFetchWithErrorTracking();
  const { call, data, loading, error } = useCall<ContactInformationResponse>(
    async () =>
      await fetchWithErrorTracking(
        `${process.env.NEXT_PUBLIC_SNAP_APP_API}/commons/company/info/CUSTOMER`,
        {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json'
          }
        }
      )
  );

  return {
    getContactInformation: call,
    getContactInformationResponse: data,
    getContactInformationLoading: loading,
    getContactInformationError: error
  };
}
